export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SinisterDates.vue?vue&type=template&id=1176577a"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/SinisterDates.vue?vue&type=template&id=1176577a
// module id = 1705
// module chunks = 31